module.exports = __webpack_public_path__ + "static/media/reel.c24cc44d.svg";